import { AgencyGroup } from '../model/agency-group';
import { AgencyGroupList } from '../model/agency-group-list';
export class AgencyGroupBuilder {
    static buildAgencyGroup(data) {
        const agencygroup = new AgencyGroup();
        agencygroup.id = data.id;
        agencygroup.name = data.name;
        agencygroup.code = data.code;
        agencygroup.email = data.email;
        agencygroup.address = data.address;
        agencygroup.city = data.city;
        agencygroup.state = data.state;
        agencygroup.dto_lot = data.dto_lot;
        agencygroup.percentage_pvp = data.percentage_pvp;
        agencygroup.phone = data.phone;
        agencygroup.fax = data.fax;
        agencygroup.zip = data.zip;
        agencygroup.nif = data.nif;
        agencygroup.company_name = data.company_name;
        agencygroup.notes = data.notes;
        return agencygroup;
    }
    static buildAgencyGroupList(data) {
        const agenciesGroup = new AgencyGroupList();
        agenciesGroup.page = data.page;
        agenciesGroup.pagination = data.pagination;
        agenciesGroup.total = data.total;
        agenciesGroup.agencies_group = _.map(data.agencies_group, (agency_group) => {
            return AgencyGroupBuilder.buildAgencyGroup(agency_group);
        });
        return agenciesGroup;
    }
}
//# sourceMappingURL=agency-group-builder.js.map